import { BRAND } from "@core/brand/brand-config";

export const faqData = {
  Credits: [
    {
      question: `What are the credit pools in ${BRAND.name}?`,
      answer: (
        <div>
          <p className="tw-mb-3 tw-text-sm tw-font-normal">{BRAND.name} uses two types of credit pools to manage feature usage:</p>
          <ul className="tw-list-disc tw-pl-5 tw-space-y-2">
            <li className="tw-font-normal tw-text-sm">
              <strong className="tw-text-gray-700 tw-font-medium tw-text-sm">Download Credit Pool</strong>: For actions like shipment downloads, company downloads, and analytics dash-let downloads.
            </li>
            <li className="tw-font-normal tw-text-sm">
              <strong className="tw-text-gray-700 tw-font-medium tw-text-sm">Value Add Credit Pool</strong>: For premium features such as accessing contact information (email/phone) , due diligence reports and HS Classification.
            </li>
          </ul>
        </div>
      ),
    },
    {
      question: "What actions consume Download Credits?",
      answer: (
        <div>
          <p className="tw-mb-3 tw-text-sm tw-font-normal">Download Credits are used for:</p>
          <ul className="tw-list-disc tw-pl-5 tw-space-y-2">
            <li className="tw-font-normal tw-text-sm">
              <strong className="tw-text-sm tw-font-medium">Shipment Download</strong> – <span className=" tw-text-primary-purple-600 tw-bg-primary-purple-50 tw-px-2 tw-py-1 tw-rounded-xl tw-font-medium">1 credit</span> per shipment
            </li>
            <li className="tw-font-normal tw-text-sm">
              <strong className="tw-text-sm tw-font-medium">Company Download</strong> – <span className=" tw-text-primary-purple-600 tw-bg-primary-purple-50 tw-px-2 tw-py-1 tw-rounded-xl tw-font-medium">5 credits</span> per company
            </li>
            <li className="tw-font-normal tw-text-sm">
              <strong className="tw-text-sm tw-font-medium">Analytics Dash-let Download</strong> – <span className=" tw-text-primary-purple-600 tw-bg-primary-purple-50 tw-px-2 tw-py-1 tw-rounded-xl tw-font-medium">1 credit</span> per report row
            </li>
          </ul>
        </div>
      ),
    },
    {
      question: "What actions consume Value Add Credits?",
      answer: (
        <div>
          <p className="tw-mb-3 tw-text-sm tw-font-normal">Value Add Credits are used for:</p>
          <ul className="tw-list-disc tw-pl-5 tw-space-y-2">
            <li className="tw-font-normal tw-text-sm">
              <strong className="tw-text-sm tw-font-medium">Due Diligence Report</strong> – <span className=" tw-text-primary-purple-600 tw-bg-primary-purple-50 tw-px-2 tw-py-1 tw-rounded-xl tw-font-medium">500 credits</span> per report
            </li>
            <li className="tw-font-normal tw-text-sm">
              <strong className="tw-text-sm tw-font-medium">Contact (Phone)</strong> – <span className=" tw-text-primary-purple-600 tw-bg-primary-purple-50 tw-px-2 tw-py-1 tw-rounded-xl tw-font-medium">5 credits</span> per phone number
            </li>
            <li className="tw-font-normal tw-text-sm">
              <strong className="tw-text-sm tw-font-medium">Contact (Email)</strong> – <span className=" tw-text-primary-purple-600 tw-bg-primary-purple-50 tw-px-2 tw-py-1 tw-rounded-xl tw-font-medium">1 credit</span> per email
            </li>
            <li className="tw-font-normal tw-text-sm">
              <strong className="tw-text-sm tw-font-medium">HS Classification</strong> – <span className=" tw-text-primary-purple-600 tw-bg-primary-purple-50 tw-px-2 tw-py-1 tw-rounded-xl tw-font-medium">5 credits</span> per classification
            </li>
            <li className="tw-font-normal tw-text-sm">
              <strong className="tw-text-sm tw-font-medium">Classified HS Justification</strong> – <span className=" tw-text-primary-purple-600 tw-bg-primary-purple-50 tw-px-2 tw-py-1 tw-rounded-xl tw-font-medium">3 credits</span> per report
            </li>
          </ul>
        </div>
      ),
    },
    {
      question: "Will I be notified before credits are deducted?",
      answer: (
        <div>
          <p className="tw-mb-3 tw-text-sm tw-font-normal">Yes. Before any credit-consuming action is performed, the system will display a confirmation message showing:</p>
          <ul className="tw-list-disc tw-pl-5 tw-space-y-2">
            <li className="tw-font-normal tw-text-sm">Number of items selected</li>
            <li className="tw-font-normal tw-text-sm">Number of credits that will be deducted</li>
            <li className="tw-font-normal tw-text-sm">Type of credit pool being used</li>
          </ul>
        </div>
      ),
    },
    {
      question: "What happens if I don't have enough credits?",
      answer: (
        <div>
          <p className="tw-text-sm tw-font-normal">If you don't have enough credits, you will not be able to proceed with the action. You can request additional credits by contacting the Customer Success team from within the product interface.</p>
        </div>
      ),
    },
    {
      question: "What happened to my earlier credits for contacts or due diligence?",
      answer: (
        <div>
          <p className="tw-mb-3 tw-text-sm tw-font-normal">All legacy credits have been migrated into the new credit pools:</p>
          <ul className="tw-list-disc tw-pl-5 tw-space-y-2">
            <li className="tw-font-normal tw-text-sm">
              <strong className="tw-text-sm tw-font-medium">Phone contact credits</strong> were converted into <span className="tw-text-gray-700 tw-font-medium tw-text-sm">Value Add Credits</span> (1 phone = 5 credits)
            </li>
            <li className="tw-font-normal tw-text-sm">
              <strong className="tw-text-sm tw-font-medium">Email contact credits</strong> were converted into <span className="tw-text-gray-700 tw-font-medium tw-text-sm">Value Add Credits</span> (1 email = 1 credit)
            </li>
          </ul>
        </div>
      ),
    },
    {
      question: "Where can I view my current credit balances?",
      answer: (
        <div>
          <p className="tw-text-sm tw-font-normal">
            Admins can view your current <span className="tw-text-gray-700 tw-font-medium tw-text-sm">Download Credits</span> and <span className="tw-text-gray-700 tw-font-medium tw-text-sm">Value Add Credits</span> under the Credits section of the UMS. For download credits and value add credits, usage can be viewed at <strong className="tw-text-sm tw-font-medium">Profile Icon &gt;&gt; UMS &gt;&gt; Credits &gt;&gt; {BRAND.shortName}</strong>.
          </p>
        </div>
      ),
    },
    {
      question: "Who do I contact for credit-related issues?",
      answer: (
        <div>
          <p className="tw-text-sm tw-font-normal">
            Please contact{" "}
            <strong className="tw-text-sm tw-font-medium">
              <a href="mailto:customersuccess@trademo" className="tw-text-primary-purple-600">
                customersuccess@trademo
              </a>
            </strong>{" "}
            or reach out to your <strong className="tw-text-sm tw-font-medium">Sales Executive</strong> for any questions or issues related to credits.
          </p>
        </div>
      ),
    },
  ],
  Search: [
    {
      question: "What are different search categories?",
      answer: (
        <>
          Basis on the subscribed dataset you can search on <span className="tw-font-medium">'Consignee', 'Shipper', 'Product', 'HS Code', 'Port', 'Logistic Company'</span>
        </>
      ),
    },
    {
      question: "Why should you search in a specific category?",
      answer: (
        <>
          Searching in a specific category like <span className="tw-font-medium">'Consignee', 'Shipper', 'Product'</span> or other will give you precise results.
        </>
      ),
    },
    {
      question: "Can multiple items be searched together?",
      answer: "Yes, you can search for multiple items upto 20 but within a single category",
    },
    {
      question: "How Exact Search is different from Contains Search?",
      answer: "When you search with two keywords for example 'Coffee Table', Exact Search will show only those results where Coffee Table is coming as a single phrase but Contains Search will give you all the results where Coffee and Table are available anywhere in the description.",
    },
    {
      question: "How to refine results using Filters?",
      answer: (
        <>
          Basis on the subscribed dataset you will get multiple filters. Open any filter like <span className="tw-font-medium">'Country of Export', 'Country of Import', 'Ports'</span> etc to filter out the results for any particular entity.
        </>
      ),
    },
    {
      question: "Where are the search logs stored?",
      answer: (
        <>
          You can access the past searches from the <span className="tw-font-medium">Search History</span> under <span className="tw-font-medium">Dashboard</span> in the <span className="tw-font-medium">Left Panel Navigation</span>
        </>
      ),
    },
    {
      question: "Can the search be saved for future reference?",
      answer: (
        <>
          Yes, you can save your search criteria using <span className="tw-font-medium">Save Search Button</span>. You can always access this from the <span className="tw-font-medium">Saved Searches Dropdown in the Header</span> or from the <span className="tw-font-medium">Search History</span> under <span className="tw-font-medium">Dashboard</span> in the <span className="tw-font-medium">Left Panel Navigation</span>
        </>
      ),
    },
  ],
  "Navigate Search Results": [
    {
      question: "What all information is shown in the results?",
      answer: "Basis on the Plan Type you would get results in different tabs like 'Shipments', 'Importers', 'Exporters', 'Logistics', 'Analytics'",
    },
    {
      question: "What does the Shipments tab represent?",
      answer: "In Shipments tab, you would get granular level details on every shipment. By clicking on View Details Icon you can view a detailed shipment with all the attributes like Shipment Origin and Destination Details, Product Details, Pricing Details etc",
    },
    {
      question: "Why are some of the columns data is shown as links?",
      answer: "Each link would help you access that profile, be it an Importer, Exporter, Port etc",
    },
    {
      question: "Can the results table in Shipments tab be configured?",
      answer: "Yes, you can configure the columns you want to see in the table by clicking on the Configure Columns Button",
    },
    {
      question: "How shipments can be downloaded?",
      answer: "You can download the shipments, by clicking on the Download Button or by selecting any shipment using Checkbox. You would get two options: Download All Columns (this would download all the columns for a shipment) or Download Columns Shown in Grid (this would download only those columns which you have configured in the grid). Each shipment download would cost you 1 download credit",
    },
    {
      question: "What does the Importers tab represent?",
      answer: "In Importers tab, you would get List of the Importers as per your search criteria. Along with the Name of Importers you would get overall volume and value of the trade as per the search criteria.",
    },
    {
      question: "What does the Exporters tab represent?",
      answer: "In Exporters tab, you would get List of the Exporters as per your search criteria. Along with the Name of Exporters you would get overall volume and value of the trade as per the search criteria.",
    },
    {
      question: "How Trends are different from Rank?",
      answer: "Trends option would help you analyse the companies basis their trade trends over montly, quarterly and yearly basis. The trade trends can be analysed basis Shipments, TEUs, Weight, Value using Sort by Options",
    },
    {
      question: "What is 2nd level analytics?",
      answer: "Enabling 2nd Level Analytics option would help you build multi dimensional report in the form of which are top countries from where the company is importing from or which are the top products in which the importing is dealing in.",
    },
    {
      question: "How companies (importers/exporters) can be downloaded?",
      answer: "You can download the list of companies using Download Button or by selecting any company using Checkbox. Each download would cost you 5 download credits",
    },
    {
      question: "How can i filter the companies (importers/exporters) basis their trade volume?",
      answer: "You can filter the companies using Filter By Button present in the right side on top of table. You can filter out the companies by defining range of shipments, weight or value. You can also filter out the companies if you want to see only those companies which have trade volume above a certain range defined by you.",
    },
    {
      question: "Can the prospect companies be exported to CRM?",
      answer: "Yes by clicking on Export to CRM you can directly export the companies in your CRM (Salesforce, Hubspot, Zoho or others)",
    },
    {
      question: "Can the prospect companies be bookmarked or starred for future reference?",
      answer: "Yes by clicking on Bookmark Button you can bookmark any company into your Bookmarked List which can be accessed from the Companies Tab in the Left Pane",
    },
    {
      question: "What does the Fetch Contact option do?",
      answer: "When you want to request contacts for multiple companies in a single go, you can select the prospect companies and click on Bulk Contact Option. Our team would find the contacts for you as per your required criteria and share with you in 24-72 working hours",
    },
    {
      question: "What does the Analytics tab present?",
      answer: "In Analytics tab, you would get macro insights like Top Countries, Top Ports, Top Trade Lanes and much more as per your search criteria",
    },
    {
      question: "What are different sorting or analysis options in Analytics Tab?",
      answer: "You can customise analytics reports basis Number of Shipments, Total Weight, Total Value or Total TEUs basis the dataset you have subscribed.",
    },
    {
      question: "What are Trends and View All options on every widget in Analytics Tab?",
      answer: "Trends option would help you analyse the entity basis their trade trends over montly, quarterly and yearly basis. The trade trends can be analysed basis Shipments, TEUs, Weight, Value using Sort by Options. View All option would help you analyse the entities by their overall trade.",
    },
  ],
};
